// extracted by mini-css-extract-plugin
module.exports = {"list":"Breadcrumbs_list__Du2rZ","item":"Breadcrumbs_item__AUPof","label":"Breadcrumbs_label__peP8i","link":"Breadcrumbs_link__wLZVz"};